import dayjs from 'dayjs';

export type PeriodPreset = 'today' | 'yesterday' | 'week' | 'month';

export interface PeriodRange {
  from: string;
  to: string;
}

export const PERIOD_PRESETS: { value: PeriodPreset; label: string }[] = [
  { value: 'today', label: 'Сегодня' },
  { value: 'yesterday', label: 'Вчера' },
  { value: 'week', label: 'Неделя' },
  { value: 'month', label: 'Месяц' },
];

const DATE_FORMAT = 'YYYY-MM-DD';

/** Границы периода-кнопки вокруг `today` — календарной даты магазина (`YYYY-MM-DD`).
 *  «Неделя» — текущая, с понедельника по воскресенье (не зависит от локали dayjs: у неё неделя
 *  может начинаться с воскресенья), «Месяц» — с 1-го числа по последнее. */
export function presetRange(preset: PeriodPreset, today: string): PeriodRange {
  const day = dayjs(today);
  switch (preset) {
    case 'today':
      return { from: today, to: today };
    case 'yesterday': {
      const yesterday = day.subtract(1, 'day').format(DATE_FORMAT);
      return { from: yesterday, to: yesterday };
    }
    case 'week': {
      // dayjs#day(): 0 — воскресенье … 6 — суббота; до понедельника — (день + 6) % 7 суток.
      const monday = day.subtract((day.day() + 6) % 7, 'day');
      return { from: monday.format(DATE_FORMAT), to: monday.add(6, 'day').format(DATE_FORMAT) };
    }
    case 'month':
      return { from: day.startOf('month').format(DATE_FORMAT), to: day.endOf('month').format(DATE_FORMAT) };
  }
}

/** Какая кнопка соответствует выбранному периоду; `undefined` — период произвольный. */
export function activePreset(range: PeriodRange, today: string): PeriodPreset | undefined {
  return PERIOD_PRESETS.find(({ value }) => {
    const candidate = presetRange(value, today);
    return candidate.from === range.from && candidate.to === range.to;
  })?.value;
}
